// @ts-check
import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { view } from '../common/constants'
import { useSelector, useDispatch } from "react-redux";
import { SET_MODEL_VIEW } from '../../redux/actions/actionTypes';

function ViewControl(props) {
  // @ts-ignore
  const viewControlsState = useSelector(state => state.viewControls);
  const dispatch = useDispatch()
  return (
    <FormControl component="fieldset">
      <RadioGroup
        row aria-label="position"
        name="position"
        defaultValue="top"
        onChange={(event) => {
          dispatch({
            type: SET_MODEL_VIEW,
            payload: event.target.value
          })
        }}
      >

        <FormControlLabel
          value={view.INTERNAL}
          control={<Radio color="secondary" />}
          label="Internal"
          labelPlacement="end"
          checked={viewControlsState.modelView === view.INTERNAL}
        />
        <FormControlLabel
          value={view.EXTERNAL}
          control={<Radio color="secondary" />}
          label="External"
          labelPlacement="end"
          checked={viewControlsState.modelView === view.EXTERNAL}
        />

      </RadioGroup>
    </FormControl>
  )
}

export default ViewControl